import React from 'react';
import SidebarComponent from './SidebarComponent';
import PageHeader from './PageHeader';

const HeavyIndustries: React.FC = () => {
  return (
    <>
      <PageHeader title="Heavy Industries" />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/about-2.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/about-3.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Heavy Industries</h1>
              <p>WTIL serves heavy industries with specialized water treatment solutions designed to meet the demanding requirements of power generation, steel production, chemical processing, and other industrial sectors. Our robust systems handle high-volume water treatment needs while ensuring operational reliability and regulatory compliance.</p>

              <p className="mb-5">Our heavy industry solutions focus on <strong>high-capacity, reliable, and cost-effective treatment systems</strong> that withstand harsh operating conditions while delivering consistent water quality for critical industrial processes and environmental protection.</p>

              <h3 className="mb-4">Industry Applications Include:</h3>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Power plants (thermal, nuclear, renewable)</p>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Steel and metal processing</p>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Chemical and petrochemical plants</p>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Cement and mining operations</p>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Pulp and paper industry</p>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Food and beverage processing</p>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Pharmaceutical manufacturing</p>

              <h3 className="mb-4">Heavy Industry Solutions:</h3>
              <p><i className="fa fa-project-diagram text-primary me-2"></i>Boiler feed water treatment</p>
              <p><i className="fa fa-project-diagram text-primary me-2"></i>Cooling tower water treatment</p>
              <p><i className="fa fa-project-diagram text-primary me-2"></i>High-pressure demineralization</p>
              <p><i className="fa fa-project-diagram text-primary me-2"></i>Process water conditioning</p>
              <p><i className="fa fa-project-diagram text-primary me-2"></i>Industrial wastewater treatment</p>
              <p><i className="fa fa-project-diagram text-primary me-2"></i>Zero liquid discharge (ZLD) systems</p>
              <p><i className="fa fa-project-diagram text-primary me-2"></i>Corrosion and scale control systems</p>
              <p className="mb-5">Our heavy industry expertise spans decades of successful projects across diverse industrial sectors, delivering robust water treatment solutions that support continuous operations, reduce downtime, and ensure environmental compliance in demanding industrial environments.</p>
            </div>

            <div className="col-lg-4">
              <SidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default HeavyIndustries;
